var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowUpTpsFoundations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66976 3.33529V12.6686H13.3364V3.33529H2.66976ZM2.00309 2.00195H14.0031C14.3713 2.00195 14.6698 2.30043 14.6698 2.66862V13.3353C14.6698 13.7035 14.3713 14.0019 14.0031 14.0019H2.00309C1.63491 14.0019 1.33643 13.7035 1.33643 13.3353V2.66862C1.33643 2.30043 1.63491 2.00195 2.00309 2.00195ZM9.86504 6.53055L8.66977 5.33529H12.0031V8.66861L10.8078 7.47335L8.23184 10.0493L6.81764 8.63515L4.93203 10.5207L3.98922 9.57795L6.81764 6.74948L8.23184 8.16368L9.86504 6.53055Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpTpsFoundations);
export default __webpack_public_path__ + "static/media/follow-up-TPS-foundations.661a417e99ad1a98af2edc6fcff2fb64.svg";
export { ForwardRef as ReactComponent };